import template from './contract_type.edit.html'
import controller from './contract_type.edit.controller'
import './contract_type.edit.scss'

const contractTypeEditComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default contractTypeEditComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract_type/edit/contract_type.edit.component.js